import Vue from 'vue'
import Vuex from 'vuex'
import test from './modules/test'
import Login from './modules/login'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    test,
    Login
  }
})

export default store
